import Vue from "vue";
import VueRouter from "vue-router";
import AddCompany from "../TaxPages/AddCompany.vue";
import SignUp from "../Pages/SignUp.vue";
import Login from "../Pages/LogIn.vue";
import Navbar from "../Pages/Navbar.vue";
import Home from "../Pages/Home.vue";
import auth from "../Middleware/auth"; 
import States from "../TaxPages/States.vue";
import Categories from "../TaxPages/Categories.vue";
import TaxRules from "../TaxPages/TaxRules.vue";
import TaxCalculation from "../TaxPages/TaxCalculation.vue";
import UploadCSVFile from "../TaxPages/UploadCSVFile.vue";
import AboutUs from "../Pages/AboutUs.vue";
import Information from "../Pages/Information.vue";
import Products from '../TaxPages/Products.vue'
import SKUTaxcalculation from '../TaxPages/SKUTaxcalculation.vue'
import PactAct from '../TaxPages/PactAct.vue'
import Help from '../TaxPages/Help.vue'
import Companies from '../TaxPages/Companies.vue'
Vue.use(VueRouter);

const routes = [
  {
    path: "/signup",
    component: SignUp,
    meta: { requiresGuest: true }, 
  },
  {
    path: "/login",
    component: Login,
    meta: { requiresGuest: true }, 
  },
  {
    path: "/",
    component: Home,
    beforeEnter: auth,
    meta: { requiresAuth: true }, 
  },
  {
    path: "/navbar",
    component: Navbar,
    beforeEnter: auth,
    meta: { requiresAuth: true },
  },
  {
    path: "/categories",
    component: Categories,
    beforeEnter: auth,
    meta: { requiresAuth: true },
  },

  {
    path: "/states",
    component: States,
    beforeEnter: auth,
    meta: { requiresAuth: true },
  },
  {
    path: "/products",
    component: Products,
    beforeEnter: auth,
    meta: { requiresAuth: true },
  },
 
  {
    path: "/taxrules",
    component: TaxRules,
    beforeEnter: auth,
    meta: { requiresAuth: true },
  },
  {
    path: "/taxcalculation",
    component: TaxCalculation,
    beforeEnter: auth,
    meta: { requiresAuth: true },
  },
  {
    path: "/uploadcsvfile",
    component: UploadCSVFile,
    beforeEnter: auth,
    meta: { requiresAuth: true },
  },
  {
    path: "/aboutus",
    component: AboutUs,
    beforeEnter: auth,
    meta: { requiresAuth: true },
  },
  {
    path: "/information",
    component: Information,
    beforeEnter: auth,
    meta: { requiresAuth: true },
  },
  {
    path: "/skutaxcalculation",
    component: SKUTaxcalculation,
    beforeEnter: auth,
    meta: { requiresAuth: true }, 
  },
  {
    path: "/pactact",
    component: PactAct,
    beforeEnter: auth,
    meta: { requiresAuth: true }, 
  },
  {
    path: "/help",
    component: Help,
    beforeEnter: auth,
    meta: { requiresAuth: true }, 
  },
   {
    path: "/companies",
    component: Companies,
    beforeEnter: auth,
    meta: { requiresAuth: true }, 
  },
   {
    path: "/addcompany",
    component: AddCompany,
    beforeEnter: auth,
    meta: { requiresAuth: true },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});


router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem("token");
  if (to.meta.requiresAuth && !isAuthenticated) {
    next("/login"); 
  } else if (to.meta.requiresGuest && isAuthenticated) {
    next("/"); 
  } else {
    next(); 
  }
});

export default router;
